import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';

import ErrorMessage from 'components/ErrorMessage';

const PriceInput = ({
  testId,
  label,
  name,
  error,
  required,
  placeholder,
  control,
  onChange,
  maxValue,
  subtitle,
  className,
  inputClassName,
  labelClassName,
  inputPrefix,
  inputSuffix,
  allowNegative,
  ...rest
}) => {
  const withValueLimit = (inputObj) => {
    const { value } = inputObj;
    if (value <= maxValue) return inputObj;
  };

  return (
    <label htmlFor={name} className={className} data-testid={testId}>
      <span className={`label ${labelClassName}`}>{label}</span>
      <div className={`input-form-wrapper ${inputClassName}`}>
        <div className="relative">
          {!!inputPrefix && (
            <span className="absolute w-11 h-auto top-0 bottom-0 left-0 flex items-center justify-center rounded-l-md border-r border-gray-300 text-javelin-gray-dark text-sm">
              {inputPrefix}
            </span>
          )}
          <Controller
            name={name}
            control={control}
            rules={{ required }}
            render={({ field: { onChange, value, ...field } }) => (
              <NumberFormat
                {...rest}
                {...field}
                id={name}
                className={`input input-full-border ${
                  inputPrefix ? 'pl-14' : ''
                } ${inputSuffix ? 'pr-14' : ''} ${!!error ? 'error' : ''}`}
                onValueChange={(v) => onChange(v.value)}
                placeholder={placeholder}
                isAllowed={withValueLimit}
                value={value}
              />
            )}
          />
          {!!inputSuffix && (
            <span className="absolute w-11 h-auto top-0 bottom-0 right-0 flex items-center justify-center rounded-r-md border-l border-gray-300 text-gray-400 font-light">
              {inputSuffix}
            </span>
          )}
        </div>
        {subtitle && (
          <p className="text-xs text-gray-400 w-full mt-1">{subtitle}</p>
        )}
        {!!error && <ErrorMessage message={error} />}
      </div>
    </label>
  );
};

PriceInput.propTypes = {
  testId: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  control: PropTypes.shape({}),
  error: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  maxValue: PropTypes.number,
  subtitle: PropTypes.string,
  allowNegative: PropTypes.bool,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
};
PriceInput.defaultProps = {
  testId: 'price-input',
  label: '',
  name: 'price',
  control: {},
  error: null,
  required: false,
  placeholder: '00.00',
  maxValue: 10000000,
  subtitle: null,
  allowNegative: false,
  labelClassName: 'pb-1 lg:pb-0 lg:w-4/12',
  className: 'flex flex-col lg:items-baseline mb-4 lg:flex-row',
  inputClassName: '',
};

export default memo(PriceInput);
